import {
  CandidaturePreviewCandidateEntryType,
  CandidaturePreviewResponseItem,
  CandidaturePreviewResponseItemCandidatingPlanEntry,
  CandidaturePreviewResponseItemCandidatingPlanEntryEndData,
  CandidaturePreviewResponseItemCandidatingPlanEntryOrderPoint,
  CandidaturePreviewResponseItemCandidatingPlanEntryOrderPointsNodeData,
  CandidaturePreviewResponseItemCandidatingPlanEntryStartData,
  CandidaturePreviewResponseItemCandidatingRequest,
  CandidaturePreviewResponseItemCreatePlanEntryCandidating,
  CandidaturePreviewResponseItemCreateSolvedOrderCandidating,
  CandidaturePreviewResponseItemDraftCandidatingPlanEntry,
  CandidaturePreviewResponseItemDraftCandidatingPlanEntryEndData,
  CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPoint,
  CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPointsNodeData,
  CandidaturePreviewResponseItemDraftCandidatingPlanEntryStartData,
  CandidaturePreviewResponseItemPlanEntry,
  CandidaturePreviewResponseItemPlanEntryEndData,
  CandidaturePreviewResponseItemPlanEntryOrderPoint,
  CandidaturePreviewResponseItemPlanEntryOrderPointsNodeData,
  CandidaturePreviewResponseItemPlanEntryStartData,
} from "../../../api/raily/candidature/preview/candidature-preview.response";
import CandidaturePreview, {
  CandidaturePreviewCandidatingPlanEntry,
  CandidaturePreviewCandidatingPlanEntryEndData,
  CandidaturePreviewCandidatingPlanEntryOrderPoint,
  CandidaturePreviewCandidatingPlanEntryStartData,
  CandidaturePreviewCandidatingPlanEntryWaypoint,
  CandidaturePreviewDraftCandidatingPlanEntry,
  CandidaturePreviewDraftCandidatingPlanEntryEndData,
  CandidaturePreviewDraftCandidatingPlanEntryOrderPoint,
  CandidaturePreviewDraftCandidatingPlanEntryStartData,
  CandidaturePreviewDraftCandidatingPlanEntryWaypoint,
  CandidaturePreviewPlanEntry,
  CandidaturePreviewPlanEntryOrderPoint,
  CandidaturePreviewPlanEntryOrderWaypoint,
  CandidaturePreviewPlanEntryStartData,
  CandidaturePreviewCandidatureEntriesRequestData,
} from "./candidature-preview";

const createDraftCandidatureEntryStartData = (
  data: CandidaturePreviewResponseItemDraftCandidatingPlanEntryStartData,
): CandidaturePreviewDraftCandidatingPlanEntryStartData => {
  return {
    address: data.address,
    date: data.date,
  };
};

const createDraftCandidatureEntryEndData = (
  data: CandidaturePreviewResponseItemDraftCandidatingPlanEntryEndData,
): CandidaturePreviewDraftCandidatingPlanEntryEndData => {
  return {
    address: data.address,
    date: data.date,
  };
};

const createDraftCandidatureEntryWaypoint = (
  data: CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPointsNodeData,
): CandidaturePreviewDraftCandidatingPlanEntryWaypoint => {
  return {
    address: data.address,
    date: data.date,
  };
};

const createDraftCandidatureEntryWaypoints = (
  data: CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPointsNodeData[],
): CandidaturePreviewDraftCandidatingPlanEntryWaypoint[] => {
  return data.map(createDraftCandidatureEntryWaypoint);
};

const createDraftCandidatureEntryOrder = (
  data: CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPoint,
): CandidaturePreviewDraftCandidatingPlanEntryOrderPoint => {
  return {
    planEntryUuid: data.humanId,
    waypoints: createDraftCandidatureEntryWaypoints(data.waypoints),
  };
};

const createDraftCandidatureEntryOrders = (
  data: CandidaturePreviewResponseItemDraftCandidatingPlanEntryOrderPoint[],
): CandidaturePreviewDraftCandidatingPlanEntryOrderPoint[] => {
  return data.map(createDraftCandidatureEntryOrder);
};

const createDraftCandidatureEntry = (
  data: CandidaturePreviewResponseItemDraftCandidatingPlanEntry,
): CandidaturePreviewDraftCandidatingPlanEntry => {
  return {
    uuid: data.id,
    candidatureUuid: data.humanId,
    start: createDraftCandidatureEntryStartData(data.start),
    end: createDraftCandidatureEntryEndData(data.end),
    orders: createDraftCandidatureEntryOrders(data.orders),
  };
};

const createDraftPlanEntries = (
  data: CandidaturePreviewResponseItemDraftCandidatingPlanEntry[],
): CandidaturePreviewDraftCandidatingPlanEntry[] => {
  return data.map(createDraftCandidatureEntry);
};

const createCandidatureEntryStartData = (
  data: CandidaturePreviewResponseItemCandidatingPlanEntryStartData,
): CandidaturePreviewCandidatingPlanEntryStartData => {
  return {
    address: data.address,
    date: data.date,
  };
};

const createCandidatureEntryEndData = (
  data: CandidaturePreviewResponseItemCandidatingPlanEntryEndData,
): CandidaturePreviewCandidatingPlanEntryEndData => {
  return {
    address: data.address,
    date: data.date,
  };
};

const createCandidatureEntryWaypoint = (
  data: CandidaturePreviewResponseItemCandidatingPlanEntryOrderPointsNodeData,
): CandidaturePreviewCandidatingPlanEntryWaypoint => {
  return {
    address: data.address,
    date: data.date,
  };
};

const createCandidatureEntryWaypoints = (
  data: CandidaturePreviewResponseItemCandidatingPlanEntryOrderPointsNodeData[],
): CandidaturePreviewCandidatingPlanEntryWaypoint[] => {
  return data.map(createCandidatureEntryWaypoint);
};

const createCandidatureEntryOrder = (
  data: CandidaturePreviewResponseItemCandidatingPlanEntryOrderPoint,
): CandidaturePreviewCandidatingPlanEntryOrderPoint => {
  return {
    planEntryUuid: data.humanId,
    waypoints: createCandidatureEntryWaypoints(data.waypoints),
  };
};

const createCandidatureEntryOrders = (
  data: CandidaturePreviewResponseItemCandidatingPlanEntryOrderPoint[],
): CandidaturePreviewCandidatingPlanEntryOrderPoint[] => {
  return data.map(createCandidatureEntryOrder);
};

const createCandidatureEntry = (
  data: CandidaturePreviewResponseItemCandidatingPlanEntry,
): CandidaturePreviewCandidatingPlanEntry => {
  return {
    uuid: data.id,
    candidatureUuid: data.humanId,
    start: createCandidatureEntryStartData(data.start),
    end: createCandidatureEntryEndData(data.end),
    orders: createCandidatureEntryOrders(data.orders),
  };
};

const createCandidatureEntries = (
  data: CandidaturePreviewResponseItemCandidatingPlanEntry[],
): CandidaturePreviewCandidatingPlanEntry[] => {
  return data.map(createCandidatureEntry);
};

const createPlanEntriesStartData = (
  data: CandidaturePreviewResponseItemPlanEntryStartData,
): CandidaturePreviewPlanEntryStartData => {
  return {
    address: data.address,
    date: data.date,
  };
};

const createPlanEntriesEndData = (
  data: CandidaturePreviewResponseItemPlanEntryEndData,
): CandidaturePreviewResponseItemPlanEntryEndData => {
  return {
    address: data.address,
    date: data.date,
  };
};

const createWaypoint = (
  data: CandidaturePreviewResponseItemPlanEntryOrderPointsNodeData,
): CandidaturePreviewPlanEntryOrderWaypoint => {
  return { address: data.address, date: data.date };
};

const createWaypoints = (
  data: CandidaturePreviewResponseItemPlanEntryOrderPointsNodeData[],
): CandidaturePreviewPlanEntryOrderWaypoint[] => {
  return data.map(createWaypoint);
};

const createPlanEntriesOrder = (
  data: CandidaturePreviewResponseItemPlanEntryOrderPoint,
): CandidaturePreviewPlanEntryOrderPoint => {
  return {
    orderId: data.humanId,
    waypoints: createWaypoints(data.waypoints),
  };
};

const createPlanEntriesOrders = (
  data: CandidaturePreviewResponseItemPlanEntryOrderPoint[],
): CandidaturePreviewPlanEntryOrderPoint[] => {
  return data.map(createPlanEntriesOrder);
};

const createPlanEntry = (
  data: CandidaturePreviewResponseItemPlanEntry,
): CandidaturePreviewPlanEntry => {
  return {
    id: data.id,
    planEntryId: data.humanId,
    start: createPlanEntriesStartData(data.start),
    end: createPlanEntriesEndData(data.end),
    orders: createPlanEntriesOrders(data.orders),
  };
};

const createPlanEntries = (
  data: CandidaturePreviewResponseItemPlanEntry[],
): CandidaturePreviewPlanEntry[] => {
  return data.map(createPlanEntry);
};

const createPlanEntryCandidating = (
  data: CandidaturePreviewResponseItemCreatePlanEntryCandidating,
): CandidaturePreviewCandidatureEntriesRequestData => {
  return {
    token: data.candidatingSolve,
    taxiCorporationUuid: data.taxiCorporationId,
    givenPlanEntryUuid: data.givenPlanEntryId,
    transportingOrderUuid: data.transportingOrderId,
  };
};

const createSolvedOrderCandidating = (
  data: CandidaturePreviewResponseItemCreateSolvedOrderCandidating,
): CandidaturePreviewCandidatureEntriesRequestData => {
  return {
    token: data.candidatingSolve,
    transportingOrderUuid: data.transportingOrderId,
  };
};

const createCandidatureEntriesRequestData = (
  data: CandidaturePreviewResponseItemCandidatingRequest,
): CandidaturePreviewCandidatureEntriesRequestData => {
  switch (data.candidateEntryType) {
    case CandidaturePreviewCandidateEntryType.CREATE_PLAN_ENTRY:
      return createPlanEntryCandidating(
        data as CandidaturePreviewResponseItemCreatePlanEntryCandidating,
      );
    case CandidaturePreviewCandidateEntryType.CREATE_SOLVED_ORDER:
      return createSolvedOrderCandidating(
        data as CandidaturePreviewResponseItemCreateSolvedOrderCandidating,
      );
  }
};

const create = (item: CandidaturePreviewResponseItem): CandidaturePreview => {
  return {
    planEntries: createPlanEntries(item.planEntries),
    candidatureEntries: createCandidatureEntries(item.candidatureEntries),
    draftCandidatureEntries: createDraftPlanEntries(
      item.draftCandidatureEntries,
    ),
    candidatureEntriesRequestData: createCandidatureEntriesRequestData(
      item.candidatingRequest,
    ),
  };
};

const candidaturePreviewFactory = { create };

export default candidaturePreviewFactory;
